import Styles from '../styles.scss';

const renderStyles = (isAdEmpty: boolean) =>
	isAdEmpty ? Styles.gptContainerHidden : Styles.gptContainerLoaded;

export { renderStyles };
